import axios from 'axios'

export default {
    getDrinkTypes() {
        return axios.get('/drinkType/v1')
            .then(response => {
                return response.data
            })
    }
}